/** The generated ATLAS symbol pairs with live type and the original Tracx wordmark. */
export function AtlasBrand({ large = false }: { large?: boolean }) {
  return (
    <span className={`atlas-identity ${large ? 'atlas-identity-large' : ''}`}>
      <img src="/brand/atlas-mark-2026.png" alt="" className="atlas-symbol" width="48" height="48" />
      <span className="atlas-wordmark">
        <span className="atlas-name">ATLAS</span>
        <span className="atlas-endorsement">by Tracx Systems</span>
      </span>
    </span>
  );
}

export function TracxBrand({ light = false }: { light?: boolean }) {
  return (
    <span className="tracx-signature">
      <img src={light ? '/brand/tracx-light.webp' : '/brand/tracx-dark.webp'} alt="Tracx Systems" width="168" height="40" />
    </span>
  );
}
